/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Collage_Field_EmailInputs */

const en_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const zh_hans1_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱`)
};

const pt_br2_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const es_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo`)
};

const fr_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const de_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const ru_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почта`)
};

const it_home_collage_field_email = /** @type {(inputs: Home_Collage_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Home_Collage_Field_EmailInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const home_collage_field_email = /** @type {((inputs?: Home_Collage_Field_EmailInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Collage_Field_EmailInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_home_collage_field_email(inputs)
	if (locale === "pt-BR") return pt_br2_home_collage_field_email(inputs)
	if (locale === "es") return es_home_collage_field_email(inputs)
	if (locale === "fr") return fr_home_collage_field_email(inputs)
	if (locale === "de") return de_home_collage_field_email(inputs)
	if (locale === "ru") return ru_home_collage_field_email(inputs)
	if (locale === "it") return it_home_collage_field_email(inputs)
	return en_home_collage_field_email(inputs)
});